import React from 'react'
import { useTranslation } from 'react-i18next'

const ShippingPolicy = () => {
    const { t } = useTranslation()

    return (
        <section className="py-100">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="content-wrapper">
                            <h2 className="text-center mb-40">{t('footer.shippingPolicy')}</h2>
                            <div className="mb-32">
                                <h4 className="mb-16">1. Shipping Methods</h4>
                                <p className="mb-8">We offer various shipping methods to meet your needs. Delivery times may vary based on your location and the shipping option you select during checkout.</p>
                                <p>All shipping options and estimated delivery times will be displayed during the checkout process.</p>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">2. Shipping Fees</h4>
                                <p className="mb-8">Shipping fees are calculated based on the destination, weight, and dimensions of your order.</p>
                                <p>The exact shipping cost will be displayed at checkout before you complete your purchase.</p>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">3. Processing Time</h4>
                                <p className="mb-8">Orders are typically processed within 1-2 business days after payment confirmation.</p>
                                <p>During peak seasons or promotional periods, processing may take longer.</p>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">4. Delivery Time</h4>
                                <p className="mb-8">Estimated delivery times are displayed during checkout and depend on your location and chosen shipping method.</p>
                                <p>Please note that delivery times are estimates and not guaranteed. Factors such as weather conditions, customs clearance, or other unforeseen circumstances may cause delays.</p>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">5. Order Tracking</h4>
                                <p className="mb-8">Once your order ships, you will receive a confirmation email with tracking information.</p>
                                <p>You can track your order status through your account on our website or using the tracking number provided.</p>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">6. International Shipping</h4>
                                <p className="mb-8">We ship internationally to most countries. International orders may be subject to import duties, taxes, and customs fees which are the responsibility of the recipient.</p>
                                <p>International delivery times may vary significantly depending on customs processing in your country.</p>
                            </div>
                            <div className="mb-32">
                                <h4 className="mb-16">7. Address Changes</h4>
                                <p>Once an order has been placed, we cannot guarantee that the shipping address can be changed. Please contact our customer service as soon as possible if you need to modify your shipping address.</p>
                            </div>
                            <div>
                                <h4 className="mb-16">8. Contact Information</h4>
                                <p>If you have any questions about our shipping policy, please contact our customer service team.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ShippingPolicy 